import { sdkLogger } from '../../logger/logger';
import type { Survey } from '../types';
import type { SdkLoggableError } from '../../types/shared';

export function logMapWarning(): void {
  sdkLogger.warn('Cannot map survey: apiResponse is null or undefined');
}

export function logMapSuccess(mappedSurvey: Survey): void {
  sdkLogger.success('Mapped survey layout successfully', { mappedSurvey });
}

export function logMapError(err: SdkLoggableError): void {
  sdkLogger.error('Failed to map survey layout', { err });
}

export function logUnknownAnswerType(answerType: string | undefined, questionId: string): void {
  sdkLogger.warn('Unknown question answerType — falling back to MCQ mapper', {
    answerType: answerType ?? '(missing)',
    questionId,
  });
}
